(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hn-branche-hero"] && !Shopify.designMode) return;
  try {
    
  /*
   * Hydronova branche-rekenhulp.
   *
   * Alle waarden zijn al door Liquid uitgerekend en geformatteerd en hangen als
   * data-attributen aan de keuzeknoppen. Deze klasse doet niets anders dan de
   * juiste waarden in beeld zetten — er wordt hier bewust niet gerekend, zodat
   * de getallen met en zonder JavaScript identiek zijn.
   *
   * Daarnaast stuurt hij bij elke keuze een `hn:branche-aansluiting`-event op
   * document, waar hn-branche-keuze op luistert.
   */
  class HnBrancheRekenhulp extends HTMLElement {
    connectedCallback() {
      if (this.hnGereed) return;
      this.hnGereed = true;

      this.knoppen = Array.from(this.querySelectorAll('[data-hn-stap]'));
      if (this.knoppen.length === 0) return;

      this.miniaturen = Array.from(this.querySelectorAll('[data-hn-mini]'));
      this.knop = this.querySelector('[data-hn-veld="knop"]');

      this.velden = {};
      ['model', 'modelsub', 'liters', 'flessen', 'tappunten', 'tappuntenlabel', 'bedrag', 'bedragsuffix'].forEach(
        (naam) => {
          this.velden[naam] = this.querySelector('[data-hn-veld="' + naam + '"]');
        }
      );

      this.knoppen.forEach((knop) => {
        knop.addEventListener('click', () => this.kies(knop));
        knop.addEventListener('keydown', (event) => this.opToets(event));
      });
    }

    opToets(event) {
      const aantal = this.knoppen.length;
      const huidig = this.knoppen.indexOf(event.currentTarget);
      let doel = -1;

      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          doel = (huidig - 1 + aantal) % aantal;
          break;
        case 'ArrowRight':
        case 'ArrowDown':
          doel = (huidig + 1) % aantal;
          break;
        case 'Home':
          doel = 0;
          break;
        case 'End':
          doel = aantal - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.knoppen[doel].focus();
      this.kies(this.knoppen[doel]);
    }

    kies(knop) {
      const data = knop.dataset;

      this.knoppen.forEach((andere) => {
        andere.setAttribute('aria-pressed', andere === knop ? 'true' : 'false');
      });

      this.miniaturen.forEach((mini) => {
        mini.hidden = mini.dataset.hnMini !== data.hnStap;
      });

      Object.keys(this.velden).forEach((naam) => {
        const veld = this.velden[naam];
        if (!veld) return;
        // dataset-sleutels zijn camelCase: hnModelsub, hnTappuntenlabel, …
        const waarde = data['hn' + naam.charAt(0).toUpperCase() + naam.slice(1)];
        veld.textContent = waarde || '';
      });

      if (this.knop) {
        const url = data.hnUrl || '';
        this.knop.hidden = url === '';
        if (url !== '') this.knop.setAttribute('href', url);
      }

      document.dispatchEvent(
        new CustomEvent('hn:branche-aansluiting', {
          detail: { aansluiting: data.hnAansluiting || '' },
        })
      );
    }
  }

  if (!customElements.get('hn-branche-rekenhulp')) {
    customElements.define('hn-branche-rekenhulp', HnBrancheRekenhulp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-branche-keuze"] && !Shopify.designMode) return;
  try {
    
  /*
   * Hydronova branchekeuze. Luistert naar de rekenhulp in hn-branche-hero en
   * verplaatst het label "past bij uw keuze" naar de kaart met dezelfde
   * aansluiting. Meer doet deze klasse niet: zonder JavaScript, of zonder
   * branchekop op de pagina, blijft het label staan op de kaart die in de
   * theme-editor als standaard is aangewezen.
   */
  class HnBrancheKeuze extends HTMLElement {
    connectedCallback() {
      if (this.hnGereed) return;
      this.hnGereed = true;

      this.kaarten = Array.from(this.querySelectorAll('[data-hn-kaart]'));
      if (this.kaarten.length === 0) return;

      this.opAansluiting = (event) => this.markeer(event.detail && event.detail.aansluiting);
      document.addEventListener('hn:branche-aansluiting', this.opAansluiting);

      // Laadsynchronisatie: de rekenhulp dispatcht zijn event alleen bij een
      // klik, dus zonder deze stap kan de badge bij laden op de verkeerde
      // kaart staan als de sectie-instelling afwijkt van de standaardstap
      // (dat gebeurde op horeca/zorg/bouw). Lees daarom de server-gerenderde
      // actieve stap van de rekenhulp en markeer meteen de juiste kaart.
      const actieveStap = document.querySelector('hn-branche-rekenhulp [aria-pressed="true"]');
      if (actieveStap && actieveStap.dataset.hnAansluiting) {
        this.markeer(actieveStap.dataset.hnAansluiting);
      }
    }

    disconnectedCallback() {
      if (this.opAansluiting) document.removeEventListener('hn:branche-aansluiting', this.opAansluiting);
      this.hnGereed = false;
    }

    markeer(aansluiting) {
      if (!aansluiting) return;

      this.kaarten.forEach((kaart) => {
        const actief = kaart.dataset.hnKaart === aansluiting;
        kaart.classList.toggle('hn-branche-keuze__kaart--actief', actief);

        const badge = kaart.querySelector('[data-hn-badge]');
        if (badge) badge.hidden = !actief;
      });
    }
  }

  if (!customElements.get('hn-branche-keuze')) {
    customElements.define('hn-branche-keuze', HnBrancheKeuze);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-bronwater-koop"] && !Shopify.designMode) return;
  try {
    
  /*
   * Bronwater-koopblok. Vier gedragingen, geen libraries:
   *
   * 1. Galerij — thumbnails wisselen het zichtbare hoofdbeeld (gestapeld,
   *    zelfde patroon als hn-pdp-koop).
   * 2. Dop- en aantalradio's — echte formulier-velden (name="id"/"quantity"),
   *    dus de bestelling klopt ook zonder JS; JS ververst alleen de
   *    prijsopbouw en de verbruikshint.
   * 3. Bestelwijze — aria-pressed-knoppen die de actieknop omwisselen
   *    (abonnement = offertelink, eenmalig = native toevoegknop).
   * 4. Prijsopbouw — alle bedragen zijn door Liquid voorberekend en staan als
   *    JSON in de sectie; hier worden alleen strings omgewisseld.
   */
  class HnBronwaterKoop extends HTMLElement {
    connectedCallback() {
      if (this.hnGereed) return;
      this.hnGereed = true;

      const dataEl = this.querySelector('[data-hn-prijzen]');
      try {
        this.prijzen = dataEl ? JSON.parse(dataEl.textContent) : {};
      } catch (e) {
        this.prijzen = {};
      }
      this.modus = this.dataset.hnStandaardModus || 'eenmalig';

      this.initGalerij();
      this.initKeuzes();
      this.initModus();
    }

    initGalerij() {
      const thumbs = Array.from(this.querySelectorAll('[data-hn-thumb]'));
      const beelden = Array.from(this.querySelectorAll('[data-hn-beeld]'));
      if (thumbs.length < 2 || beelden.length < 2) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = thumb.dataset.hnThumb;
          thumbs.forEach((andere) => {
            const actief = andere.dataset.hnThumb === index;
            andere.setAttribute('aria-pressed', actief ? 'true' : 'false');
            andere.classList.toggle('hn-bronwater-koop__thumb--actief', actief);
          });
          beelden.forEach((beeld) => {
            beeld.hidden = beeld.dataset.hnBeeld !== index;
          });
        });
      });
    }

    initKeuzes() {
      const radios = Array.from(this.querySelectorAll('[data-hn-variant], [data-hn-aantal]'));
      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          this.zetVrij(false);
          this.ververs();
        });
      });
      this.initVrijAantal();
    }

    /*
     * Vrij aantal. De staffelradio's heten name="quantity" en het vrije veld
     * ook: precies één van beide mag meesturen. Daarom wisselt deze methode
     * tussen twee toestanden — staffel: veld `disabled` (disabled houdt een
     * veld écht buiten de FormData, hidden niet); vrij: alle staffelradio's
     * uitgevinkt zodat er geen tweede quantity meegaat.
     * Zonder JS gebeurt er niets en blijft de staffelkeuze gewoon werken.
     */
    initVrijAantal() {
      this.vrijRadio = this.querySelector('[data-hn-vrij-radio]');
      this.vrijVeld = this.querySelector('[data-hn-vrij-veld]');
      if (!this.vrijRadio || !this.vrijVeld) return;

      this.vrijRadio.addEventListener('change', () => {
        if (this.vrijRadio.checked) this.zetVrij(true);
      });
      this.vrijVeld.addEventListener('focus', () => {
        this.vrijRadio.checked = true;
        this.zetVrij(true);
      });
      this.vrijVeld.addEventListener('input', () => this.ververs());
    }

    zetVrij(aan) {
      if (!this.vrijRadio || !this.vrijVeld) return;
      this.vrijVeld.disabled = !aan;
      if (aan) {
        Array.from(this.querySelectorAll('[data-hn-aantal]')).forEach((radio) => {
          radio.checked = false;
        });
      } else {
        this.vrijRadio.checked = false;
      }
    }

    toonVrij() {
      const aantal = parseInt(this.vrijVeld.value, 10);
      const hintVeld = this.querySelector('[data-hn-hint-veld]');
      if (!Number.isFinite(aantal) || aantal < 1) return;

      // Hoogste staffel waarvan de drempel gehaald wordt.
      let beste = null;
      Array.from(this.querySelectorAll('[data-hn-aantal]')).forEach((radio) => {
        const drempel = parseInt(radio.dataset.hnAantal, 10);
        const prijs = radio.dataset.hnPrijs;
        if (prijs && drempel <= aantal && (!beste || drempel > beste.drempel)) {
          beste = { drempel: drempel, prijs: prijs };
        }
      });
      if (hintVeld) {
        hintVeld.textContent = beste
          ? aantal + ' flessen · ' + beste.prijs + ' per fles — totaal in de winkelwagen'
          : aantal + ' flessen';
      }
    }

    initModus() {
      const knoppen = Array.from(this.querySelectorAll('[data-hn-modus]'));
      if (knoppen.length < 2) return;

      knoppen.forEach((knop) => {
        knop.addEventListener('click', () => {
          this.modus = knop.dataset.hnModus;
          knoppen.forEach((andere) => {
            andere.setAttribute('aria-pressed', andere.dataset.hnModus === this.modus ? 'true' : 'false');
          });
          Array.from(this.querySelectorAll('[data-hn-actie]')).forEach((actie) => {
            actie.hidden = actie.dataset.hnActie !== this.modus;
          });
          this.ververs();
        });
      });
    }

    ververs() {
      const variant = this.querySelector('[data-hn-variant]:checked');
      const aantal = this.querySelector('[data-hn-aantal]:checked');
      // Zonder dopkaartjes (één variant) draagt het verborgen veld de id.
      const variantId = variant ? variant.value : (this.querySelector('[ref="variantId"]') || {}).value;

      // Vrij aantal: er is geen voorberekende combinatie voor een willekeurig
      // getal. We tonen dan de staffelprijs per fles die van toepassing is
      // (door Liquid geformatteerd, dus geen geldopmaak in JS); het totaal
      // volgt in de winkelwagen, waar de staffelkorting wordt verrekend.
      if (this.vrijRadio && this.vrijRadio.checked) {
        this.toonVrij();
        return;
      }
      if (!variantId || !aantal) return;

      const combi = this.prijzen[variantId + ':' + aantal.value + ':' + this.modus];
      if (!combi) return;

      const zet = (sel, tekst) => {
        const el = this.querySelector(sel);
        if (el && tekst != null) el.textContent = tekst;
      };
      zet('[data-hn-water]', combi.water);
      zet('[data-hn-statiegeld]', combi.statiegeld);
      zet('[data-hn-totaal]', combi.totaal);
      zet('[data-hn-vervolg-bedrag]', combi.vervolg);
      zet('[data-hn-hint-veld]', aantal.dataset.hnHint || '');

      const sjabloon = this.querySelector('[data-hn-water-sjabloon]');
      if (sjabloon) zet('[data-hn-water-label]', sjabloon.textContent.trim().replace('AANTAL', aantal.value));
    }
  }

  if (!customElements.get('hn-bronwater-koop')) {
    customElements.define('hn-bronwater-koop', HnBronwaterKoop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-faq-overzicht"] && !Shopify.designMode) return;
  try {
    
  /*
   * Filteren op categorie en zoeken in de vragen. Beide volledig client-side:
   * er wordt niets herladen en er is geen app in het spel.
   *
   * Zonder JavaScript staan alle vragen zichtbaar en doen de pillen niets — de
   * inhoud is dan compleet, alleen het filteren ontbreekt.
   *
   * Het zoekveld staat in de paginakop (hn-service-kop) en niet in deze sectie;
   * daarom wordt het op document-niveau opgezocht.
   */
  class HnFaqOverzicht extends HTMLElement {
    connectedCallback() {
      if (this.hnGereed) return;
      this.hnGereed = true;

      this.groepen = Array.from(this.querySelectorAll('[data-hn-groep]'));
      this.items = Array.from(this.querySelectorAll('[data-hn-vraag]'));
      this.pillen = Array.from(this.querySelectorAll('[data-hn-filter]'));
      this.totaal = this.querySelector('[data-hn-totaal]');
      this.geenTreffers = this.querySelector('[data-hn-geen-treffers]');
      if (this.groepen.length === 0) return;

      this.categorie = '';
      this.zoekterm = '';

      this.pillen.forEach((pil) => {
        pil.addEventListener('click', () => {
          // Nogmaals op dezelfde pil klikken zet het filter weer uit.
          const gekozen = pil.dataset.hnFilter;
          this.categorie = this.categorie === gekozen ? '' : gekozen;
          this.pas_toe();
        });
      });

      // "1 vragen" leest als een slordigheid; het enkelvoud staat als data-attribuut.
      this.eenheid = (aantal) =>
        aantal + ' ' + (aantal === 1 ? this.totaal.dataset.hnEenheidEnkel : this.totaal.dataset.hnEenheid);

      this.zoekveld = document.querySelector('[data-hn-zoekveld]');
      if (this.zoekveld) {
        // Het zoekveld staat in de paginakop, het resultaatgebied hier; de
        // koppeling voor hulptechnologie kan dus pas op dit moment gelegd worden.
        const hoofd = this.querySelector('.hn-faq__hoofd');
        if (hoofd && hoofd.id) this.zoekveld.setAttribute('aria-controls', hoofd.id);
        this.zoekveld.addEventListener('input', () => {
          this.zoekterm = this.zoekveld.value.trim().toLowerCase();
          this.pas_toe();
        });
      }
    }

    pas_toe() {
      let zichtbaar = 0;

      this.items.forEach((item) => {
        const groep = item.closest('[data-hn-groep]');
        const inCategorie = !this.categorie || groep.dataset.hnGroep === this.categorie;
        const inZoek =
          !this.zoekterm || (item.dataset.hnVraag || '').toLowerCase().includes(this.zoekterm);
        const toon = inCategorie && inZoek;
        item.hidden = !toon;
        if (toon) zichtbaar += 1;
      });

      // Een categorie zonder zichtbare vragen verdwijnt inclusief zijn kop,
      // anders blijft er een lege kop met een aantal boven een lege kaart staan.
      this.groepen.forEach((groep) => {
        const over = Array.from(groep.querySelectorAll('[data-hn-vraag]')).filter((i) => !i.hidden);
        groep.hidden = over.length === 0;
        const teller = groep.querySelector('[data-hn-groep-aantal]');
        if (teller && this.totaal) teller.textContent = this.eenheid(over.length);
      });

      this.pillen.forEach((pil) => {
        const actief = pil.dataset.hnFilter === this.categorie;
        pil.classList.toggle('hn-faq__pil--actief', actief && pil.classList.contains('hn-faq__pil'));
        if (pil.hasAttribute('aria-pressed')) pil.setAttribute('aria-pressed', actief ? 'true' : 'false');
      });

      if (this.totaal) {
        this.totaal.textContent = this.eenheid(zichtbaar);
      }
      if (this.geenTreffers) {
        this.geenTreffers.hidden = zichtbaar > 0;
      }
    }
  }

  if (!customElements.get('hn-faq-overzicht')) {
    customElements.define('hn-faq-overzicht', HnFaqOverzicht);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-formulier"] && !Shopify.designMode) return;
  try {
    
  /*
   * Keuzepillen. Elke groep schrijft de gekozen waarde in een verborgen veld,
   * zodat hij meegaat in de mail — pillen zijn knoppen, geen invoervelden.
   *
   * Hoort er bij een optie een extra vraag (ordernummer, serienummer), dan
   * verschijnt dat veld eronder en wisselt de hint in het berichtveld mee.
   *
   * Zonder JavaScript staat de eerste optie gemarkeerd, blijft het extra veld
   * verborgen en is het formulier gewoon te versturen. Het verborgen veld is
   * dan leeg; dat is beter dan een keuze suggereren die de bezoeker niet
   * gemaakt heeft.
   */
  class HnFormulier extends HTMLElement {
    connectedCallback() {
      if (this.hnGereed) return;
      this.hnGereed = true;

      this.bericht = this.querySelector('[data-hn-bericht]');
      this.groepen = Array.from(this.querySelectorAll('[data-hn-keuze]'));

      this.groepen.forEach((groep) => {
        const waardeveld = groep.querySelector('[data-hn-keuze-waarde]');
        const knoppen = Array.from(groep.querySelectorAll('[data-hn-optie]'));
        const extra = groep.querySelector('[data-hn-extra]');
        const extraLabel = groep.querySelector('[data-hn-extra-labeltekst]');
        const extraInvoer = groep.querySelector('[data-hn-extra-invoer]');
        if (knoppen.length === 0) return;

        const meerkeuze = groep.hasAttribute('data-hn-meerkeuze');

        const kies = (knop) => {
          if (meerkeuze) {
            // Aan- en uitzetten per pil; de waarde wordt een opsomming.
            const nu = knop.getAttribute('aria-pressed') === 'true';
            knop.classList.toggle('hn-formulier__pil--actief', !nu);
            knop.setAttribute('aria-pressed', nu ? 'false' : 'true');
            if (waardeveld) {
              waardeveld.value = knoppen
                .filter((k) => k.getAttribute('aria-pressed') === 'true')
                .map((k) => k.dataset.hnOptie)
                .join(', ');
            }
            return;
          }

          knoppen.forEach((andere) => {
            const actief = andere === knop;
            andere.classList.toggle('hn-formulier__pil--actief', actief);
            andere.setAttribute('aria-pressed', actief ? 'true' : 'false');
          });

          if (waardeveld) waardeveld.value = knop.dataset.hnOptie || '';

          if (extra) {
            const label = knop.dataset.hnExtraLabel || '';
            const vorigLabel = extraLabel ? extraLabel.textContent : '';
            extra.hidden = label === '';
            if (extraLabel) extraLabel.textContent = label;
            if (extraInvoer) {
              extraInvoer.placeholder = knop.dataset.hnExtraHint || '';
              // Een verborgen veld hoort niets mee te sturen. Alleen de waarde
              // wissen is daarvoor niet genoeg: `hidden` verbergt het veld wel,
              // maar het POST nog steeds — en dan staat er een lege regel in de
              // mail. Uitgeschakelde velden worden helemaal niet verstuurd.
              extraInvoer.disabled = label === '';
              // Een ander label is een andere vraag: de oude invoer wist mee,
              // anders komt bijv. een ordernummer als serienummer in de mail.
              if (label === '' || label !== vorigLabel) extraInvoer.value = '';
            }
          }

          if (this.bericht && knop.dataset.hnBerichtHint) {
            this.bericht.placeholder = knop.dataset.hnBerichtHint;
          }
        };

        knoppen.forEach((knop) => knop.addEventListener('click', () => kies(knop)));

        // Bij één keuze staat de eerste optie in de opmaak al gemarkeerd; hier
        // wordt de bijbehorende waarde en hint alsnog gezet. Bij meerkeuze
        // gebeurt er niets: dan heeft de bezoeker nog niets gekozen.
        if (!meerkeuze) kies(knoppen[0]);
      });
    }
  }

  if (!customElements.get('hn-formulier')) {
    customElements.define('hn-formulier', HnFormulier);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-koelerkeuze"] && !Shopify.designMode) return;
  try {
    
  class HnKoelerkeuzeHulp extends HTMLElement {
    connectedCallback() {
      if (this.hnGereed) return;
      this.hnGereed = true;

      this.knoppen = Array.from(this.querySelectorAll('[data-hn-teamknop]'));
      this.kaarten = Array.from(this.querySelectorAll('[data-hn-kaartteam]'));
      this.voetnoot = this.querySelector('[data-hn-voetnoot]');

      this.knoppen.forEach((knop) => {
        knop.addEventListener('click', () => this.kies(knop.dataset.hnTeamknop));
        knop.addEventListener('keydown', (event) => this.opToets(event));
      });
    }

    opToets(event) {
      const aantal = this.knoppen.length;
      if (aantal === 0) return;

      const huidig = this.knoppen.indexOf(event.currentTarget);
      let doel = -1;

      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          doel = (huidig - 1 + aantal) % aantal;
          break;
        case 'ArrowRight':
        case 'ArrowDown':
          doel = (huidig + 1) % aantal;
          break;
        case 'Home':
          doel = 0;
          break;
        case 'End':
          doel = aantal - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.knoppen[doel].focus();
      this.kies(this.knoppen[doel].dataset.hnTeamknop);
    }

    kies(team) {
      if (!team) return;

      this.knoppen.forEach((knop) => {
        knop.setAttribute('aria-pressed', knop.dataset.hnTeamknop === team ? 'true' : 'false');
      });

      let samenvatting = '';

      this.kaarten.forEach((kaart) => {
        const aanbevolen = kaart.dataset.hnKaartteam === team;
        kaart.classList.toggle('hn-koelerkeuze__kaart--aanbevolen', aanbevolen);

        const badge = kaart.querySelector('[data-hn-badge]');
        if (badge) badge.hidden = !aanbevolen;

        if (aanbevolen && !samenvatting) {
          samenvatting = kaart.dataset.hnSamenvatting || '';
        }
      });

      if (this.voetnoot) {
        this.voetnoot.textContent = samenvatting || this.voetnoot.dataset.hnStandaard || '';
      }
    }
  }

  if (!customElements.get('hn-koelerkeuze-hulp')) {
    customElements.define('hn-koelerkeuze-hulp', HnKoelerkeuzeHulp);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-natuur"] && !Shopify.designMode) return;
  try {
    
  /*
   * Hydronova — parallax-achtergrond voor de sectie "Natuur in elke druppel water".
   *
   * Waarom geen `background-attachment: fixed`?
   * Dat rendert niet op iOS Safari en werkt sowieso niet wanneer de pagina in
   * een scrollende container staat in plaats van in het venster.
   *
   * Waarom niet op `window` luisteren?
   * Horizon zet vanaf 990px `html` en `body` op `height: 100dvh; overflow: hidden`
   * en laat `.page-wrapper` scrollen (zie assets/base.css en
   * assets/scroll-container.js). Een `window`-scrollistener vuurt daar nooit en
   * `window.scrollY` blijft 0: de parallax zou stil kapot zijn — hij rendert
   * prima maar beweegt nooit. Onder 990px scrollt het document zelf weer. De
   * scroller wordt daarom op runtime opgezocht en bij elke breekpuntwissel
   * opnieuw bepaald.
   *
   * Werking: één scroll-listener zet een vlag, één requestAnimationFrame doet
   * de layout-lezing en schrijft de transform. Een IntersectionObserver zet het
   * hele rekenwerk uit zodra de sectie buiten beeld staat.
   */
  class HnNatuurParallax extends HTMLElement {
    connectedCallback() {
      this.laag = this.querySelector('[data-hn-laag]');
      this.sectie = this.closest('.hn-natuur');
      if (!this.laag || !this.sectie) return;

      this.sterkte = parseFloat(this.dataset.hnSterkte);
      if (!isFinite(this.sterkte)) this.sterkte = 0;

      this.wacht = false;
      this.zichtbaar = false;

      /* Eenmalig binden. Wordt het element binnen dezelfde ouder verplaatst,
         dan vuurt de connected-reactie volgens de spec opnieuw zónder
         voorafgaande disconnected-reactie. Zouden we hier opnieuw binden, dan
         wijst removeEventListener naar een verse functie en blijft de oude
         listener eeuwig hangen. Met stabiele referenties is een tweede
         addEventListener bovendien een no-op. */
      if (!this.gebonden) {
        this.opScroll = this.opScroll.bind(this);
        this.teken = this.teken.bind(this);
        this.herzie = this.herzie.bind(this);

        this.mqRust = window.matchMedia('(prefers-reduced-motion: reduce)');
        /* Onder 750px staat de parallax uit. Reden: tijdens momentum-scrollen op
           touch levert de browser scroll-events geknepen en vertraagd aan, dus de
           laag loopt zichtbaar achter en schokt. Daar komt bij dat de sectie op
           een telefoon bijna het hele scherm vult, waardoor het effect nauwelijks
           afleesbaar is, terwijl het wel elke frame GPU-werk en dus batterij kost.
           Dempen in plaats van uitzetten lost het schokken niet op — alleen de
           amplitude — dus is het volledig uit. */
        this.mqBreed = window.matchMedia('(min-width: 750px)');
        /* Horizon's squeeze-layout: vanaf 990px scrollt .page-wrapper. */
        this.mqSqueeze = window.matchMedia('(min-width: 990px)');

        this.gebonden = true;
      }

      this.mqRust.addEventListener('change', this.herzie);
      this.mqBreed.addEventListener('change', this.herzie);
      this.mqSqueeze.addEventListener('change', this.herzie);

      this.herzie();
    }

    disconnectedCallback() {
      this.stop();
      this.mqRust?.removeEventListener('change', this.herzie);
      this.mqBreed?.removeEventListener('change', this.herzie);
      this.mqSqueeze?.removeEventListener('change', this.herzie);
    }

    /* Bepaalt of de parallax aan mag en bouwt de listeners opnieuw op.
       Draait bij het opstarten en bij elke wissel van breekpunt of
       bewegingsvoorkeur. */
    herzie() {
      this.stop();
      if (this.sterkte <= 0) return;
      if (this.mqRust.matches) return;
      if (!this.mqBreed.matches) return;
      this.start();
    }

    start() {
      const scroller = this.vindScroller();

      /* Is de scroller het document zelf, dan is de IntersectionObserver-root
         null (= het venster) en luisteren we op window. Is het een element,
         dan moet dat element zowel de root als het listener-doel zijn. */
      const isDocument =
        !scroller || scroller === document.documentElement || scroller === document.body || scroller === document;

      this.wortel = isDocument ? null : scroller;
      this.doel = this.wortel || window;

      this.doel.addEventListener('scroll', this.opScroll, { passive: true });
      window.addEventListener('resize', this.opScroll, { passive: true });

      this.waarnemer = new IntersectionObserver(
        (items) => {
          this.zichtbaar = items.some((item) => item.isIntersecting);
          this.sectie.classList.toggle('hn-natuur--beweegt', this.zichtbaar);
          if (this.zichtbaar) this.opScroll();
        },
        { root: this.wortel, rootMargin: '15% 0px' }
      );
      this.waarnemer.observe(this.sectie);
    }

    stop() {
      if (this.doel) {
        this.doel.removeEventListener('scroll', this.opScroll);
        this.doel = null;
      }
      if (this.opScroll) window.removeEventListener('resize', this.opScroll);
      if (this.waarnemer) {
        this.waarnemer.disconnect();
        this.waarnemer = null;
      }
      this.wortel = null;
      this.zichtbaar = false;
      this.wacht = false;
      if (this.sectie) this.sectie.classList.remove('hn-natuur--beweegt');
      if (this.laag) this.laag.style.transform = '';
    }

    /* Zoekt de container die daadwerkelijk scrollt. Eerst het geval dat
       Horizon zelf hanteert, daarna een generieke terugval over de eigen
       voorouders — alleen een voorouder kan onze scroller zijn, dus dat is
       goedkoper en preciezer dan de hele DOM aflopen.

       Vanaf 990px vertrouwen we .page-wrapper onvoorwaardelijk, precies zoals
       assets/scroll-container.js dat doet. Bewust géén overflow-controle hier:
       zolang een drawer openstaat zet Horizon `scroll-lock` op <html> en krijgt
       .page-wrapper `overflow: hidden`. Zo'n momentopname zou de terugval naar
       window activeren en de parallax tot de volgende breekpuntwissel stil
       doodleggen. */
    vindScroller() {
      if (this.mqSqueeze.matches) {
        const wrapper = this.closest('.page-wrapper') || document.querySelector('.page-wrapper');
        if (wrapper) return wrapper;
      }

      let ouder = this.parentElement;
      while (ouder && ouder !== document.body && ouder !== document.documentElement) {
        if (ouder.scrollHeight > ouder.clientHeight + 50 && this.heeftScrollOverflow(ouder)) return ouder;
        ouder = ouder.parentElement;
      }

      return document.scrollingElement || document.documentElement;
    }

    heeftScrollOverflow(el) {
      const overflow = window.getComputedStyle(el).overflowY;
      return overflow === 'auto' || overflow === 'scroll';
    }

    opScroll() {
      if (!this.zichtbaar || this.wacht) return;
      this.wacht = true;
      requestAnimationFrame(this.teken);
    }

    teken() {
      this.wacht = false;
      if (!this.laag || !this.sectie) return;

      /* Alle layout-lezingen staan bij elkaar vóór de enige schrijfactie, zodat
         de browser per frame hoogstens één reflow hoeft te doen. */
      const vak = this.sectie.getBoundingClientRect();
      let vensterTop = 0;
      let vensterHoogte;

      if (this.wortel) {
        vensterTop = this.wortel.getBoundingClientRect().top;
        vensterHoogte = this.wortel.clientHeight;
      } else {
        vensterHoogte = window.innerHeight || document.documentElement.clientHeight;
      }

      const hoogte = vak.height;
      if (!hoogte || !vensterHoogte) return;

      /* voortgang 0 = de sectie komt net onderin binnen, 1 = hij is er
         bovenlangs net uit. */
      const top = vak.top - vensterTop;
      let voortgang = (vensterHoogte - top) / (vensterHoogte + hoogte);
      if (voortgang < 0) voortgang = 0;
      if (voortgang > 1) voortgang = 1;

      /* De reisafstand is exact de overhang die de laag in CSS heeft
         (sterkte% boven en onder), dus de foto laat nooit een rand zien.
         De laag zakt terwijl de pagina omhoog gaat: de achtergrond beweegt
         daardoor langzamer dan de sectie en oogt verder weg. */
      const reis = (hoogte * this.sterkte) / 100;
      const y = (voortgang - 0.5) * 2 * reis;

      this.laag.style.transform = 'translate3d(0, ' + y.toFixed(2) + 'px, 0)';
    }
  }

  if (!customElements.get('hn-natuur-parallax')) {
    customElements.define('hn-natuur-parallax', HnNatuurParallax);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-pdp-koop"] && !Shopify.designMode) return;
  try {
    
  /*
   * Hydronova PDP-hoofdblok. Vier kleine gedragingen, geen libraries:
   *
   * 1. Schakelaar Kopen/Huren — echte <button>'s met aria-pressed. Zonder JS
   *    staat het koopaneel open en het huurpaneel op `hidden`; huren is een
   *    link naar de offertepagina, dus daar gaat nooit een bestelling verloren.
   * 2. Galerij — thumbnails wisselen welk hoofdbeeld zichtbaar is. De beelden
   *    staan gestapeld in het frame in plaats van dat we één src omwisselen:
   *    dat scheelt een herlaadflits en houdt de alt-teksten kloppend.
   * 3. Variantkaartjes — de radio's heten `id` en gaan dus vanzelf mee in de
   *    FormData; JS werkt alleen de grote prijs en de hoeveelheidsregels bij.
   * 4. Aantal — plus/min rond het getalveld, geklemd op min/max/step.
   */
  class HnPdpKoop extends HTMLElement {
    connectedCallback() {
      if (this.hnGereed) return;
      this.hnGereed = true;

      this.initSchakelaar();
      this.initGalerij();
      this.initVarianten();
      this.initTredes();
      this.initAantal();
      this.initAanvullingen();
    }

    initSchakelaar() {
      const tabs = Array.from(this.querySelectorAll('[data-hn-modus]'));
      const panelen = Array.from(this.querySelectorAll('[data-hn-paneel]'));
      if (tabs.length < 2 || panelen.length < 2) return;

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const modus = tab.dataset.hnModus;
          tabs.forEach((andere) => {
            andere.setAttribute('aria-pressed', andere.dataset.hnModus === modus ? 'true' : 'false');
          });
          panelen.forEach((paneel) => {
            paneel.hidden = paneel.dataset.hnPaneel !== modus;
          });
        });
      });
    }

    initGalerij() {
      const thumbs = Array.from(this.querySelectorAll('[data-hn-thumb]'));
      const beelden = Array.from(this.querySelectorAll('[data-hn-beeld]'));
      if (thumbs.length < 2 || beelden.length < 2) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = thumb.dataset.hnThumb;

          thumbs.forEach((andere) => {
            const actief = andere.dataset.hnThumb === index;
            andere.setAttribute('aria-pressed', actief ? 'true' : 'false');
            andere.classList.toggle('hn-pdp-koop__thumb--actief', actief);
          });

          beelden.forEach((beeld) => {
            beeld.hidden = beeld.dataset.hnBeeld !== index;
          });
        });
      });
    }

    initVarianten() {
      const radios = Array.from(this.querySelectorAll('[data-hn-variant]'));
      if (radios.length === 0) return;

      const prijs = this.querySelector('[data-hn-prijs]');
      const aantalVeld = this.querySelector('[data-hn-aantal-veld]');

      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked) return;

          if (prijs && radio.dataset.hnVariantPrijs) prijs.textContent = radio.dataset.hnVariantPrijs;

          if (aantalVeld) {
            const min = Number(radio.dataset.hnVariantMin) || 1;
            const stap = Number(radio.dataset.hnVariantStap) || 1;
            aantalVeld.min = String(min);
            aantalVeld.step = String(stap);
            if ((Number(aantalVeld.value) || 0) < min) aantalVeld.value = String(min);
          }
        });
      });
    }

    initTredes() {
      const hintVeld = this.querySelector('[data-hn-trede-hintveld]');
      const tredes = Array.from(this.querySelectorAll('[data-hn-trede]'));
      if (tredes.length === 0) return;

      tredes.forEach((trede) => {
        trede.addEventListener('change', () => {
          if (!trede.checked || !hintVeld) return;
          hintVeld.textContent = trede.dataset.hnTredeHint || '';
        });
      });
    }

    /**
     * Vinkblok "Direct mee bestellen": houdt de verborgen items[n]-velden in de
     * pas met de vinkjes (alleen aangevinkte regels versturen aantal en "Hoort
     * bij"), laat extra's met data-hn-aanv-per-apparaat het aantal machines
     * volgen en toont het meelopende totaal. Het versturen zelf doet Horizons
     * product-form.js — die leest het formulier ongewijzigd uit.
     */
    initAanvullingen() {
      const blok = this.querySelector('[data-hn-aanv]');
      if (!blok) return;

      const vinken = Array.from(blok.querySelectorAll('[data-hn-aanv-vink]'));
      const aantalVeld = this.querySelector('[data-hn-aantal-veld]');
      const totaalRij = blok.querySelector('[data-hn-aanv-totaal-rij]');
      const totaal = blok.querySelector('[data-hn-aanv-totaal]');
      const alles = blok.querySelector('[data-hn-aanv-alles]');

      const machines = () => Math.max(1, parseInt(aantalVeld ? aantalVeld.value : '1', 10) || 1);
      const basisCenten = () => {
        const radio = this.querySelector('[data-hn-variant]:checked');
        return Number((radio && radio.dataset.hnVariantCenten) || blok.dataset.hnAanvBasis) || 0;
      };
      // Zelfde notatie als Liquid's money-filter in dit theme: "€575,00".
      const euro = (centen) =>
        '€' + (centen / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      const sync = () => {
        const n = machines();
        let extra = 0;
        let aan = 0;
        for (const vink of vinken) {
          const rij = vink.closest('li');
          if (!rij) continue;
          const aantal = vink.hasAttribute('data-hn-aanv-per-apparaat') ? n : 1;
          const aantalInvoer = rij.querySelector('[data-hn-aanv-aantal]');
          const hoortBij = rij.querySelector('[data-hn-aanv-prop]');
          if (aantalInvoer) {
            aantalInvoer.value = String(aantal);
            aantalInvoer.disabled = !vink.checked;
          }
          if (hoortBij) hoortBij.disabled = !vink.checked;
          if (vink.checked) {
            extra += (Number(vink.dataset.hnAanvCenten) || 0) * aantal;
            aan += 1;
          }
        }
        if (totaalRij && totaal) {
          totaalRij.hidden = aan === 0;
          totaal.textContent = euro(basisCenten() * n + extra);
        }
        if (alles) alles.hidden = aan === vinken.length;
      };

      vinken.forEach((vink) => vink.addEventListener('change', sync));
      if (alles) {
        alles.addEventListener('click', () => {
          vinken.forEach((vink) => {
            vink.checked = true;
          });
          sync();
        });
      }
      if (aantalVeld) {
        aantalVeld.addEventListener('input', sync);
        aantalVeld.addEventListener('change', sync);
      }
      this.querySelectorAll('[data-hn-variant]').forEach((radio) => radio.addEventListener('change', sync));
      // Vangnet vlak vóór het versturen (capture op de voorouder van het formulier).
      this.addEventListener('submit', sync, true);
      sync();
    }

    initAantal() {
      const veld = this.querySelector('[data-hn-aantal-veld]');
      // Op tredeproducten staat er geen vrije teller; dan is er niets te doen.
      if (!veld) return;

      const knoppen = Array.from(this.querySelectorAll('[data-hn-aantal]'));

      knoppen.forEach((knop) => {
        knop.addEventListener('click', () => {
          const stap = Number(veld.step) || 1;
          const min = Number(veld.min) || 1;
          const max = veld.max ? Number(veld.max) : Number.POSITIVE_INFINITY;
          const huidig = Number(veld.value) || min;
          const nieuw = knop.dataset.hnAantal === 'plus' ? huidig + stap : huidig - stap;

          veld.value = String(Math.min(max, Math.max(min, nieuw)));
          // Het vinkblok rekent aantal en totaal mee; programmatisch zetten vuurt geen input-event.
          veld.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
    }
  }

  if (!customElements.get('hn-pdp-koop')) {
    customElements.define('hn-pdp-koop', HnPdpKoop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hn-service-layout"] && !Shopify.designMode) return;
  try {
    
  /*
   * Postcodecheck. Volledig client-side: de reeksen staan als instelling in het
   * blok ("7400-7699, 7500-7549"), er is dus geen app of API in het spel.
   *
   * Zonder ingevulde reeksen rendert het invoerveld niet eens — zie de Liquid
   * hierboven. Deze klasse hoeft dus alleen het geval te dekken waarin er wél
   * gecontroleerd kan worden.
   */
  class HnServiceVeld extends HTMLElement {
    connectedCallback() {
      if (this.hnGereed) return;
      this.hnGereed = true;

      this.invoer = this.querySelector('[data-hn-invoer]');
      this.knop = this.querySelector('[data-hn-controleer]');
      this.uitslag = this.querySelector('[data-hn-uitslag]');
      if (!this.invoer || !this.knop || !this.uitslag) return;

      this.reeksen = (this.dataset.hnReeksen || '')
        .split(',')
        .map((deel) => deel.trim().split('-').map((getal) => parseInt(getal, 10)))
        .filter((paar) => paar.length === 2 && !isNaN(paar[0]) && !isNaN(paar[1]));

      this.knop.addEventListener('click', () => this.controleer());
      this.invoer.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.controleer();
        }
      });
    }

    controleer() {
      // Alleen de vier cijfers tellen; "7411 AB" en "7411AB" horen hetzelfde te doen.
      const cijfers = (this.invoer.value.match(/\d{4}/) || [])[0];
      if (!cijfers) {
        // Geen vier cijfers is iets anders dan buiten het bezorggebied liggen;
        // die twee mogen niet dezelfde melding krijgen.
        this.uitslag.textContent = this.dataset.hnOngeldig || '';
        return;
      }

      const getal = parseInt(cijfers, 10);
      const binnen = this.reeksen.some((paar) => getal >= paar[0] && getal <= paar[1]);
      this.uitslag.textContent = (binnen ? this.dataset.hnTreffer : this.dataset.hnMisser) || '';
    }
  }

  if (!customElements.get('hn-service-veld')) {
    customElements.define('hn-service-veld', HnServiceVeld);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
